import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    :root { 
        --primary-heading-font-size: 24px;
        --primary-heading-font-weight: 700;
        --primary-paragraph-font-size: 21px;
        --primary-paragraph-font-color: #282829;
        --primary-paragraph-line-height: 28px;
        --primary-small-label-font-size: 18px;
        --primary-hover-background-color: #f2eee5;
        --primary-fellora-logo-color: #1DA1F2;
        --primary-accent-gold: #c9a063;
        --primary-base-cream: #faf7f2;
        --primary-light-paragraph-font-color: #939598;
        --primary-border-color: rgba(201, 160, 99, 0.25);
        --primary-body-background-color: #faf7f2;
     }
        
    *, *::before, *::after {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Caveat', cursive, sans-serif;
    }

    body {
        overflow-x: hidden;
        overflow-y: scroll;
        background-color: #faf7f2;
        font-size: 21px;
        line-height: 1.45;
        letter-spacing: 0.3px;
        background-image:
            linear-gradient(rgba(250, 247, 242, 0.90), rgba(250, 247, 242, 0.90)),
            url("assets/site-bg.jpg"),
            repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(180, 155, 110, 0.045) 3px, rgba(180, 155, 110, 0.045) 4px),
            repeating-linear-gradient(90deg, transparent, transparent 3px, rgba(180, 155, 110, 0.045) 3px, rgba(180, 155, 110, 0.045) 4px);
        background-size: cover, cover, auto, auto;
        background-position: center center;
        background-attachment: fixed;
        background-repeat: no-repeat;
    }

    p {
        cursor: default;
        font-size: 21px;
        line-height: 1.45;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    button, input, textarea, select {
        font-family: 'Caveat', cursive, sans-serif;
        font-size: 20px;
    }

    /* Caveat bold for Headings, Usernames, Community names, and items requiring emphasis */
    h1, h2, h3, h4, h5, h6,
    .author,
    .cName,
    .cname,
    .m-name,
    .fellow-name,
    .text-menu-name,
    .user-info h4,
    .my-comm,
    .c-name,
    .explore-name,
    .name,
    .header-left,
    .CommRowName,
    .community-name,
    .info h1,
    .qNav_logo,
    .create-row,
    .createSpace p,
    .author-name,
    .post-title,
    .header-title,
    .card-header strong,
    strong,
    b {
        font-weight: 700 !important;
        letter-spacing: 0.3px;
    }

    .author-name,
    .fellow-name,
    .cname,
    .cName,
    .community-name,
    .user-info h4 {
        font-size: 22px !important;
    }

    .post-title, h4.post-title, .textContent h4 {
        font-size: 25px !important;
        font-weight: 700 !important;
        line-height: 1.35 !important;
    }

`;
